import React from 'react';
import { TranslationUtils } from '../../utils';
import './ReceiptMor.scss';
import { ReceiptLineSummary } from './ReceiptLineSummary';
import { useIntl } from 'react-intl';

interface ReceiptSummaryProps {
    summary: {
        currency: string;
        rent: number;
        tax_amount: number;
        fees: number;
        total: number;
        trip_protection_fee?: number;
    };
    trip_protection: null | boolean;
    trip_protection_text?: string;
    locale: string;
    checkInDateTime: string;
    checkOutDateTime: string;
}

export const ReceiptSummary: React.FC<ReceiptSummaryProps> = (props) => {
    const intl = useIntl();
    const { checkInDateTime, checkOutDateTime, summary, trip_protection, trip_protection_text, locale } = props;

    const formattedCheckIn = intl.formatDate(checkInDateTime, { month: 'short', year: 'numeric', day: 'numeric' });
    const formattedCheckOut = intl.formatDate(checkOutDateTime, { month: 'short', year: 'numeric', day: 'numeric' });

    return (
        <div id="items-summary" className="receipt-summary">
            <ReceiptLineSummary
                summaryTitle={`${TranslationUtils.get('rent')} (${formattedCheckIn} - ${formattedCheckOut})`}
                summaryValue={summary.rent}
                currency={summary.currency}
                locale={locale}
            />

            <ReceiptLineSummary
                summaryTitle={`${TranslationUtils.get('fees')}`}
                summaryValue={summary.fees}
                currency={summary.currency}
                locale={locale}
            />

            <ReceiptLineSummary
                summaryTitle={`${TranslationUtils.get('taxes')}`}
                summaryValue={summary.tax_amount}
                currency={summary.currency}
                locale={locale}
            />

            {trip_protection != null && (
                <React.Fragment>
                    {trip_protection && summary.trip_protection_fee ? (
                        <ReceiptLineSummary
                            summaryTitle={trip_protection_text ? trip_protection_text : TranslationUtils.get('trip_protection')}
                            summaryValue={summary.trip_protection_fee}
                            currency={summary.currency}
                            locale={locale}
                        />
                    ) : (
                        <ReceiptLineSummary
                            summaryTitle={TranslationUtils.get('trip_protection')}
                            summaryValue={TranslationUtils.get('not_purchased')}
                            currency={summary.currency}
                            locale={locale}
                        />
                    )}
                </React.Fragment>
            )}
        </div>
    );
};
